<app-header-translator>    
</app-header-translator>
<app-product-spotlight
    [title]="headerTitle()"
    [textContent]="'MOBILEHOME.HEADER_TEXT' | translate"
    [imageFilePath]="'/files/assets/img/mobilehome-spotlight.jpg'">
</app-product-spotlight>

<app-general *ngIf="!showQuestions" (gotoQuestionPageEvent)="goToQuestionPage($event)" [policytype] = "policytype"  #general></app-general>
<app-questions *ngIf="showQuestions" (gotoGeneralPageEvent)="goToGeneralPage($event)" [policytype] = "policytype" [yesCompare]="yesCompare" #questions></app-questions>
